import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  workspace: {
    name: "",
    id: "",
  },
};

export const isClickupSlice = createSlice({
  name: "clickup",
  initialState,
  reducers: {
    setWorkspace: (state, { payload }) => {
      state.workspace = payload.workspace;
    },
  },
});

export const { setWorkspace } = isClickupSlice.actions;
